<template>
  <section class="sku_section sku-service">
    <div class="section_title">
      <span class="title" @click="toServer" role="link" tabindex="0">
        <span>服务</span>
        <span class="icon"></span>
      </span>
    </div>
    <div class="section_content" role="listbox" aria-multiselectable="true">
      <template v-for="item in service">
        <div
          class="sku_btn"
          :key="item.id"
          @click="selectService(item)"
          :class="{ 'sku_btn--checked': item.id == (checkedService[item.type] && checkedService[item.type].id) }"
          tabindex="0"
          role="option"
          :aria-selected="item.id == (checkedService[item.type] && checkedService[item.type].id) ? 'true' : 'false'"
        >
          <span class="name" :aria-label="item.id == (checkedService[item.type] && checkedService[item.type].id) ? '' : `未选中,${item.name}`">{{ item.name }}</span>
          <span class="price" :aria-label="`${item.salePrice}元`">￥{{ item.salePrice | formatNumber }}</span>
          <span class="badge" v-if="item.salePrice < item.marketPrice">
            <i class="text" v-if="item.type == 4 || item.type == 7 || item.type == 9">
              省￥{{ (item.marketPrice - item.salePrice) | formatNumber }}
            </i>
            <i class="text" v-else>限时优惠</i>
          </span>
        </div>

        <!-- 服务说明 -->
        <div class="service_detail" tabindex="0" v-if="isShowDetail(item)" :key="'detail-' + item.id">
          <p class="title fs-30">{{ item.name }}包含：</p>
          <p class="msg">{{ item.intro }}</p>
        </div>
      </template>
    </div>

    <!-- 服务协议 -->
    <div class="agreement" v-if="isServiceInited">
      <v-checkbox v-model="isAgree" @click="isAgree = !isAgree" scale="0.8"></v-checkbox>
      <span class="label fs-30" @click="isAgree = !isAgree">我已阅读并同意</span>
      <span aria-label="vivo服务条款"></span>
      <a
        class="terms fs-30"
        href="javascript:void(0);"
        @click="
          toVivoCare(
            '/helpcenter/vivo-care-pact?broken=' +
              hasServiceType(1) +
              '&extend=' +
              hasServiceType(2) +
              '&backCover=' +
              hasServiceType(3) +
              '&vivoCare=' +
              hasServiceType(4) +
              '&valueChange=' +
              hasServiceType(5) +
              '&accidentFix=' +
              hasServiceType(6) +
              '&renewal=' +
              hasServiceType(7) +
              '&battery=' +
              hasServiceType(8) +
              '&vivoCareNew=' +
              hasServiceType(9) +
              '&vivoCarePlus=' +
              isVivoCarePlus +
              '&active=' +
              activeTerm
          )
        "
      >
        <span aria-hidden="true">《</span>
        <span class="underline">vivo服务条款</span>
        <span aria-hidden="true">》</span>
      </a>
    </div>
  </section>
</template>

<script>
import config from 'config'
export default {
  name: 'SkuService',
  props: {
    service: Array,
    checkedService: {
      type: Object,
      default() {
        return {}
      }
    },
    trackData: Object
  },
  data() {
    return {
      isServiceInited: false, // 当用户选择过服务后，协议才会出现，否则默认不出现
      isAgree: false // 是否勾选了服务协议
    }
  },
  computed: {
    activeTerm() {
      let result = 'broken'
      const serviceMap = {
        1: 'broken',
        2: 'extend',
        3: 'backCover',
        4: 'vivoCare',
        5: 'valueChange',
        6: 'accidentFix',
        7: 'renewal',
        8: 'battery',
        9: 'vivoCareNew',
        10: 'vivoCarePlus',
        11: 'vivoCarePlus'
      }
      for (let key in this.checkedService) {
        if (this.checkedService[key] && this.checkedService[key].id != '') {
          result = serviceMap[key]
          break
        }
      }
      return result
    },
    isVivoCarePlus() {
      return this.hasServiceType(10) || this.hasServiceType(11)
    }
  },
  watch: {
    checkedService: {
      deep: true,
      handler(checked) {
        checked = Object.values(checked).filter(item => !!item)
        // 只要有选中的服务，则自动同意协议
        this.isAgree = !!checked.length
        if (checked.length) {
          this.isServiceInited = true
        }
      }
    },
    isAgree(isAgree) {
      // 如果不同意协议，则取消所有选中项
      if (!isAgree) {
        this.$emit('serviceChange', 0)
      }
    }
  },
  methods: {
    // 选中服务
    selectService(service) {
      this.$emit('serviceChange', service.type, this.checkedService[service.type] === service ? '' : service)
      // 点击埋点
      let data = this.trackData
      data.button = service.id
      this.$track(data)
    },
    // 是否展示服务说明
    isShowDetail(service) {
      const type = service.type
      if (type == 4 || type == 7 || type == 9 || type == 10 || type == 11) {
        return service.id == (this.checkedService[type] && this.checkedService[type].id)
      }
      return false
    },
    // 是否有某个类型的服务，有返回1，无返回0
    hasServiceType(type) {
      return this.service.find(item => item.type == type) ? 1 : 0
    },
    // 跳转至服务条款
    toServer() {
      this.$subPage({
        url: config.path.service
      })
    },
    // 跳转到服务条款
    toVivoCare(route) {
      let newUrl = 'https://shop.vivo.com.cn/wap' + route
      this.$subPage({
        url: newUrl
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
